import React, { useEffect } from "react";
import i18n from "@/utils/i18n";
import { ToastProps } from "@/types/component";
import "./index.scss";

const SuccessIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="11" cy="11" r="11" fill="#15AC77" />
    <path
      d="M6.5 11L9.5 14L15.5 8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FailIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="11" cy="11" r="11" fill="currentColor" />
    <path
      d="M14 8L8 14M8 8L14 14"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Toast: React.FC<ToastProps> = ({
  variant,
  title,
  message,
  onClose,
  duration = 5000,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const defaultTitle = variant === "success" ? i18n.t("toast.success") : i18n.t("toast.fail");
  const displayTitle = title ?? defaultTitle;

  return (
    <div className={`snackbar snackbar--${variant}`} role="alert">
      <div className="snackbar__content">
        <span className="snackbar__icon">
          {variant === "success" ? <SuccessIcon /> : <FailIcon />}
        </span>
        <div className="snackbar__text">
          <span className="snackbar__title">{displayTitle}</span>
          <span className="snackbar__message"> {message}</span>
        </div>
      </div>
      <button
        type="button"
        className="snackbar__close"
        onClick={onClose}
        aria-label="Kapat"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default Toast;
